import React, {Component} from 'react'

export default class PersonalData extends Component {

    constructor(props) {
        super();
        this.state = {
            profile: props.profile,
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            profile: nextProps.profile
        })
    }

    render() {
        let createdAt = this.state.profile.created_at
            ? this.state.profile.created_at.substring(0, 10)
            : '';

        return (
            <section id='personal-data'>
                <div className='row'>
                    <div className='col-md-6 offset-md-3'>
                        <table className='table table-striped table-bordered'>
                            <tbody>
                            <tr>
                                <td>Teljes név</td>
                                <td>{this.state.profile.last_name} {this.state.profile.first_name}</td>
                            </tr>
                            <tr>
                                <td>Email cím</td>
                                <td>{this.state.profile.email}</td>
                            </tr>
                            <tr>
                                <td>Regisztráció</td>
                                <td>{createdAt}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/personaldata.js